<div class="container">
    <div class="right-side"></div>
    <form class="login-form-wrap" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="centered-wrapper">
            <div class="login-container">
                <h2 class="welcome">Welcome!  </h2>
                <p class="info">Sign in to get started</p>
                <div class="login-form">
                    <div class="form-group">
                        <mat-form-field class="example-full-width" style="width: 100%;">
                            <mat-label>Email</mat-label>
                            <input type="email" class="form-control" matInput formControlName="email"
                                placeholder="Ex. pat@example.com">
                        </mat-form-field>
                        @if(loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
                        <div>
                            @if(loginForm.get('email')?.hasError('email') &&
                            !loginForm.get('email')?.hasError('required')) {
                            <div class="error">
                                Please enter a valid email address.
                            </div>
                            }
                            @if(loginForm.get('email')?.hasError('required')) {
                            <div class="error">
                                Email is required.
                            </div>
                            }
                        </div>
                        }
                    </div>
                    <div class="form-group">
                        <mat-form-field class="example-full-width" style="width: 100%;">
                            <mat-label>Password</mat-label>
                            <input type="password" class="form-control" matInput formControlName="password">
                        </mat-form-field>
                        @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
                        <div class="error">
                            Password is required
                        </div>
                        }
                    </div>
                    <button class="login-btn" mat-flat-button type="submit" [disabled]="loginForm.invalid"
                        style="width:100%">Login</button>
                </div>
            </div>

        </div>
        <div class="disclaimer-wrap">
            <div class="disclaimer">
                <div class="disclaimer-item">
                    <span class="disclaimer-checkbox">
                        <mat-checkbox formControlName="disclaimer"></mat-checkbox>
                    </span>
                    <div class="disclaimer-txt">I understand that I am fully responsible for any documents uploaded to the app. I acknowledge that the app does not guarantee that the content of the summaries generated is complete, accurate, or free from errors. While it is designed to assist me in my work, it should not be considered a substitute for my professional judgment or expertise. I will always verify the information and use my discretion when relying on the summaries provided. Additionally, I confirm that I have the necessary rights to upload any documents and that I am not infringing on any copyright or intellectual property rights. By checking this box, I confirm that I understand and accept these terms.</div>
                </div>
                <div class="disclaimer-item disclaimer-terms-item">
                    <span class="disclaimer-checkbox">
                        <mat-checkbox formControlName="terms"></mat-checkbox>
                    </span>
                    <div class="disclaimer-txt">Please read the following terms and conditions and provide consent: <a href="https://evarooms.merckgroup.com/Topic/MerckData/mygpt/terms-conditions" target="_blank">Merck Data and Analytics MyGPT Terms&Conditions</a></div>
                </div>
                @if ((loginForm.get('disclaimer')?.invalid && loginForm.get('disclaimer')?.touched) || (loginForm.get('terms')?.invalid && loginForm.get('terms')?.touched)) {
                    <div class="error disclaimer-error">
                        Please accept the terms and conditions to proceed.
                    </div>
                }
            </div>
        </div>
    </form>
</div>

@if(isLoading){
<app-loader></app-loader>
}